import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/font.css'
Vue.config.productionTip = false;
Vue.use(Vant);

import { Lazyload } from 'vant';

Vue.use(Lazyload);
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");